import React from 'react';
import { Link } from 'react-router-dom';
import { FiEdit, FiTrash2, FiEye, FiCheckCircle, FiArchive, FiLock } from 'react-icons/fi';
import './BaselineList.css';

const BaselineList = ({ baselines, onDelete, onApprove, onArchive }) => {
  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      'Draft': 'badge-warning',
      'Active': 'badge-success',
      'Archived': 'badge-secondary',
      'Superseded': 'badge-info'
    };
    return statusClasses[status] || 'badge-secondary';
  };

  const getTypeBadgeClass = (type) => {
    const typeClasses = {
      'Initial': 'badge-primary',
      'Revised': 'badge-info',
      'Current': 'badge-success',
      'Final': 'badge-dark'
    };
    return typeClasses[type] || 'badge-secondary';
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'INR'
    }).format(amount || 0);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="baseline-list">
      {baselines.length === 0 ? (
        <div className="empty-state">
          <p>No baselines found</p>
          <Link to="/app/baselines/create" className="btn btn-primary">
            Create First Baseline
          </Link>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Project</th>
                <th>Version</th>
                <th>Type</th>
                <th>Status</th>
                <th>Baseline Date</th>
                <th>Planned Budget</th>
                <th>Duration (Days)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {baselines.map((baseline) => (
                <tr key={baseline.id}>
                  <td>
                    <div className="baseline-name">
                      {baseline.is_locked && (
                        <FiLock className="lock-icon" title="Locked" />
                      )}
                      <Link to={`/app/baselines/${baseline.id}`}>
                        {baseline.name}
                      </Link>
                    </div>
                  </td>
                  <td>
                    {baseline.project ? (
                      <Link to={`/app/projects/${baseline.project.id}`}>
                        {baseline.project.name}
                      </Link>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    <span className="version-badge">{baseline.version}</span>
                  </td>
                  <td>
                    <span className={`badge ${getTypeBadgeClass(baseline.baseline_type)}`}>
                      {baseline.baseline_type}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${getStatusBadgeClass(baseline.status)}`}>
                      {baseline.status}
                    </span>
                  </td>
                  <td>{formatDate(baseline.baseline_date)}</td>
                  <td>{formatCurrency(baseline.planned_budget)}</td>
                  <td>{baseline.planned_duration_days || 'N/A'}</td>
                  <td>
                    <div className="action-buttons">
                      <Link
                        to={`/app/baselines/${baseline.id}`}
                        className="btn btn-sm btn-info"
                        title="View"
                      >
                        <FiEye />
                      </Link>
                      {!baseline.is_locked && baseline.status === 'Draft' && (
                        <>
                          <Link
                            to={`/app/baselines/${baseline.id}/edit`}
                            className="btn btn-sm btn-primary"
                            title="Edit"
                          >
                            <FiEdit />
                          </Link>
                          <button
                            onClick={() => onApprove(baseline.id)}
                            className="btn btn-sm btn-success"
                            title="Approve"
                          >
                            <FiCheckCircle />
                          </button>
                        </>
                      )}
                      {baseline.status === 'Active' && (
                        <button
                          onClick={() => onArchive(baseline.id)}
                          className="btn btn-sm btn-warning"
                          title="Archive"
                        >
                          <FiArchive />
                        </button>
                      )}
                      {!baseline.is_locked && baseline.status !== 'Active' && (
                        <button
                          onClick={() => onDelete(baseline.id)}
                          className="btn btn-sm btn-danger"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BaselineList;


